const luxon = require("luxon");
import _ from 'lodash';
var format = require('string-template');
export default class DateFormatter {

    constructor(datetime = null, params = {}) {
        this.locale = 'fr';
        this.timezone = 'Europe/London';
        this.today_text = params?.today_text || 'Today';
        this.tomorrow_text = params?.tomorrow_text || 'Tomorrow';
        this.starts_in_less_than = params?.starts_in_less_than || 'Starts in less than';
        this.minutes = params?.minutes || 'minutes';
        this.hours = params?.hours || 'hours';
        this.starting_soon = params?.starting_soon || 'Starting soon';

        if(datetime) {
            this.datetime = luxon.DateTime.fromISO(datetime).toUTC();
        } else {
            this.datetime = luxon.DateTime.now().toUTC();
        }        
        return this
    }

    setLocale(locale) {
        this.locale = locale;
        return this
    }

    setTimezone(timezone) {
        this.timezone = timezone;
        return this
    }

    isAfter(time = null) {
        try {
            if (time == null) {
                return this.datetime > luxon.DateTime.now().toUTC()
            }
            return this.datetime > time.datetime
        } catch(e) {
            console.warn(e);
        }
        return false;
    }

    startsIn() {

        let now = luxon.DateTime.now()
        
        let diff = this.datetime.setLocale(this.locale).setZone(this.timezone).diff(now, ["hours"])
        if(_.get(diff, 'hours') <= 4 && _.get(diff, 'hours') > 1) {
            return this.starts_in_less_than + ' ' + Math.ceil(_.get(diff, 'hours')) + ' ' + this.hours
        }
        if(_.get(diff, 'hours') <= 1) {
            diff = this.datetime.setLocale(this.locale).setZone(this.timezone).diff(now, ["minutes"])
            if(_.get(diff, 'minutes') > 1) {
                return this.starts_in_less_than + ' ' + Math.ceil(_.get(diff, 'minutes')) + ' ' + this.minutes
            }
            if(_.get(diff, 'minutes') < 1) {
                return this.starting_soon
            }
        }

        return this.formatRelative('MMM dd, H:mm');

    }

    isBefore(time = null) {
        try {
            if (time == null) {
                return this.datetime < luxon.DateTime.now().toUTC()
            }
            return this.datetime < time.datetime
        } catch(e) {

        }
        return false;
    }

    toMillis() {
        return this.datetime.toMillis()
    }

    format(format) {
        return _.capitalize(this.datetime.setLocale(this.locale).setZone(this.timezone).toFormat(format))
    }

    formatDay() {
        return _.capitalize(this.datetime.setLocale(this.locale).setZone(this.timezone).toRelativeCalendar())
    }
    formatWeekday() {
        let tomorrow = luxon.DateTime.now().plus({days: 1}).endOf('day').toUTC()
        let today = luxon.DateTime.now().endOf('day').toUTC()
        let day_string = _.capitalize(this.datetime.setLocale(this.locale).setZone(this.timezone).toFormat('cccc'))
        if(this.datetime <= tomorrow) {
            day_string = this.tomorrow_text
        }
        if(this.datetime <= today) {
            day_string = this.today_text
        }
        return day_string
    }

    formatRelative(format) {
        //let days = this.datetime.setLocale(this.locale).setZone(this.timezone).diff(luxon.DateTime.now().toUTC(), ['days']).toObject();
        //days = days.days
        let hour = _.capitalize(this.datetime.setLocale(this.locale).setZone(this.timezone).toFormat('H:mm'))

        let today = luxon.DateTime.now().endOf('day').toUTC()
        if(this.datetime <= today) {
          return this.today_text + ", " + hour
        }

        let tomorrow = luxon.DateTime.now().plus({days: 1}).endOf('day').toUTC()
        if(this.datetime <= tomorrow) {
          return this.tomorrow_text + ", " + hour
        }

        return _.capitalize(this.datetime.setLocale(this.locale).setZone(this.timezone).toFormat('MMM dd')) + ", " + hour
    }

}